import React from 'react'
import InlineNotification from '@veneer/core/dist/esm/scripts/inline_notification'
import classes from './FooterNote.module.scss'

const FooterNote = ({ children }) => {
  return (
    <InlineNotification
      className={classes.footerNote}
      closeButton={false}
      description={children}
      hideIcon
      status="information"
    />
  )
}

export default FooterNote
